import Vue from 'vue'
import Mutations from '../data/mutations'
export default {
  namespaced: true,
  state: {
    clients: [],
    listView: false,
    sortBy: "",
    filterBy: "",
    loadingClients: false
  },
  mutations: Mutations,
  actions: {
    resetForm(context) {
      context.commit('modifyContractor', "")
      context.commit('modifyClient', "")
      context.commit('modifyVehicle', "")
      context.commit('modifySite', "")
      context.commit('resetTrips')
    }
  },
  getters: {
    getClients: state => state.clients
  }
}